import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

import type { ZodiacSign } from '@entities/profile/types';

interface Filters {
  age: {
    from: number | null;
    to: number | null;
  } | null;
  hasAbout: boolean | null;
  isVerified: boolean | null;
  goals: string[] | null;
  alcoholViews: string[] | null;
  smokingViews: string[] | null;
  hasChildren: string[] | null;
  zodiac: ZodiacSign[] | null;
  height: {
    from: number | null;
    to: number | null;
  } | null;
}

interface FiltersState {
  filters: Filters;
  setFilters: (values: Filters) => void;
  getFiltersCount: () => number;
}

export const defaultPremiumFilters = {
  hasAbout: null,
  isVerified: null,
  goals: null,
  alcoholViews: null,
  smokingViews: null,
  hasChildren: null,
  zodiac: null,
  height: {
    from: null,
    to: null,
  },
};

export const defaultFilters: Filters = {
  age: {
    from: null,
    to: null,
  },
  ...defaultPremiumFilters,
};

export const useFiltersStore = create<FiltersState>()(
  persist(
    (set, get) => ({
      filters: defaultFilters,
      setFilters: (filters) => set({ filters }),
      getFiltersCount: () => {
        const { filters } = get();

        let count = 0;
        Object.entries(filters).forEach(([, value]) => {
          if (value !== null) {
            if (typeof value === 'object') {
              Object.values(value).forEach((subValue) => {
                if (subValue !== null) {
                  count++;
                }
              });
            } else {
              count++;
            }
          }
        });
        return count;
      },
    }),
    {
      name: 'filters-storage',
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
